var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button"},on:{"click":_vm.handleButtonClick}},[(_vm.isPlaying)?_c('n-icon-base',[_c('n-icon-pause')],1):_c('n-icon-base',[_c('n-icon-play')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }